function lib(){
    const Library = {"Library":[
        {"header": "Wideseal", "characters":[
            // //Arle and Lyster
            {"name": "Arle and Lyster Gyle", "pronouns": "he/him and she/her",
            "description": "The twin kahmogi owners of the Gyle Well. Arle manages the mechanics while Lyster keeps the books. Feuding since fairly recently, each one suspects the other of sabotage.",
            "url": "https://cdn.discordapp.com/attachments/837882618799849563/943860166758125578/20220212_023854.jpg"},
    
            // //Aarthi
            {"name":"Aarthi Khatri",
            "pronouns": "she/her", 
            "description": "A smith's apprentice. Always seems to have some injury or another.",
            "url": "https://cdn.discordapp.com/attachments/837882618799849563/943860167013969931/20220212_023940.jpg"},

            //Enmides
            {"name": "Enmides Brook", 
            "pronouns": "he/him", 
            "description": "Dragonborn captain of the Raidyll Guard. Recently deputized our heroes.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/916736124481831022/Enmides.jpg"},

            //Fortinbras
            {"name": "Fortinbras", 
            "pronouns": "she/her", 
            "description": "Earth genasi and proprietor of Fort's Porp-Up Shorp.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/962412381324071053/20220409_140141.jpg"},

            //Guido 
            {"name": "Guido Pilter", 
            "pronouns": "he/him", 
            "description": "The annoying ratfolk foreman.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/916729655158009937/Guido.jpg"},

            // //Irving
            // {"name": "Irving Ballast", "pronouns": "any/all", "description": "Shifter member of the Wideseal Platoon. Bored with lookout duty, she collects stories, but he also requires an audience that meets his...standards.",
            // "url": ""},

            //Michael
            {"name": "Michael 'Mikey' Morgan", 
            "pronouns": "she/her", 
            "description": "The noctern (nocturnal intern) of the Gyle Oil Well and Refinery, who works Thursday nights.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/981772594845990942/20220602_001258.jpg"},

            //Roke
            {"name": "Roke Brassfist", 
            "pronouns": "she/her", 
            "description": "Dwarven sheriff of the Wideseal settlement, so named for her brass hand which replaced the one she lost in the Gradian catastrophe.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/929412291265458206/Roke.jpg"},

            //Skipo
            {"name": "Skipo", 
            "pronouns": "he/him", 
            "description": "Excitable young aliam bard. Idolizes anyone who claims or even appears to be an adventurer.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/962412381596688415/20220409_140144.jpg"},

            //The Gourd
            {"name": "The Gradian Gourd", 
            "pronouns": "N/A?", 
            "description": "An automaton, or perhaps suit of armor, created within the Wideseal Enigma for an unknown purpose.",
            "url": "https://cdn.discordapp.com/attachments/837882618799849563/943860166380621844/20220212_024008.jpg"},

            //Zeereth
            {"name": "Zeereth Vrinn", 
            "pronouns": "she/her", 
            "description": "This gung-ho drow is a mutual friend of Gal's and Piper's. Has a bit of an aromatherapy habit.",
            "url": "https://cdn.discordapp.com/attachments/837882618799849563/943890980220850176/zeereth.JPG"}
            ]},
        
        {"header": "Mariners", "characters":[
            //Silt
            {"name": "Silt", "pronouns": "he/they", "description": "The Mariners' \"inside man.\" Reports directly to Methuselah.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/916739090962075658/Silt.jpg"},

            //Nadir
            {"name": "Nadir", "pronouns": "she/her", "description": "A mid-ranking Mariner, and the Mariner's savior.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/916726816788602930/Nadir.jpg"},
            
            //Methuselah
            {"name": "Methuselah", "pronouns": "he/him", "description": "The silent leader of the Mariners. In lieu of speaking, Silt interprets.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/916747294202814524/Nadir1.jpg"},

            // //Puddle
            {"name": "Puddle", "pronouns": "he/him", "description": "The newest Mariner, and a big fan of the Mariner. Recently deceased!",
            "url": "https://cdn.discordapp.com/attachments/837882618799849563/947158492731551785/20220226_104905.jpg"},
            ]},

        {"header": "Others", "characters":[
            //Dr. Bonejaw
            {"name": "Dr. Merrow Bonejaw", 
            "pronouns": "he/him", 
            "description": "A scientist from Numines. Used to work under Enmides, now works solely with his colleague Dr. Stonejaw. Allegedly does weird science.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/1005356692755726356/20220806_020748.jpg"},

            //Dr. Stonejaw
            {"name": "Dr. Wrett Stonejaw",
            "pronouns": "she/her",
            "description": "A scientist from Numines. A chemist by trade, and Dr. Bonejaw's colleague.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/1005356693019963543/20220806_020310.jpg"},

            //Velour
            {"name": "Velour Quickheel",
            "pronouns": "he/him",
            "description": "A haughty soldier from Raidyll, under the command of Fresh Hunt.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/1013163185085362296/Velour.jpg"},

            //Fresh Hunt
            {"name": "Fresh Hunt",
            "pronouns": "she/he",
            "description": "A higher-up in the Raidyll guard. Her methods might seem harsh, but the results speak for themselves.",
            "url": "https://cdn.discordapp.com/attachments/916569335336677396/1013163184733048872/Fresh_Hunt.jpg"},
        ]}
    ]}

    return Library;
}

export default lib;